import ZCheckbox from './ZCheckbox.vue'

export default ZCheckbox
